export default {
    // 活动详情接口
    getActivityDetail: '/amc/client/getActivityById',
    // 通过活动Id和用户Id获取会员的报名状况
    getApplyStatus: '/amc/client/getApplyStatus',
    // 通过活动Id和电话获取会员的报名状况
    getApplyStatusByActivityIdAndPhone: '/amc/client/getApplyStatusByActivityIdAndPhone',
    // 获取用户报名详细（基础信息和动态字段信息）
    getApplyMemberDetail: '/amc/client/getApplyMemberDetail',
    // 获取报名自定义表单
    getApplyMemberModelByActivityId: '/amc/client/getApplyMemberModelByActivityId',
    // 会员报名
    addApplyMember: '/amc/client/addApplyMember',
    // 会员报名并签到
    addApplyMemberAndSignIn: '/amc/client/addApplyMemberAndSignIn',
    // 获取参赛作品自定义表单
    getApplyFormModelByActivityId: '/amc/client/getApplyFormModelByActivityId',
    // 会员提交参赛作品
    addApplyForm: '/amc/client/addApplyForm',
    // 会员修改参赛作品
    updateApplyFormForYTH: '/amc/client/updateApplyFormForYTH',
    // H5签到页面获取短信验证码
    getAuthCodeBySignIn: '/amc/client/getAuthCodeBySignIn',
    // 签到
    activitySignInByPhone: '/amc/client/activitySignInByPhone',
    // 根据活动ID和会员ID判断是否已经签到
    isSignIn: '/amc/client/isSignIn',

    // 根据活动Id查询参赛作品列表
    listApplyFormByActivityId: '/amc/client/listApplyFormByActivityId',
    // 根据活动Id查询参赛作品列表
    listApplyFormByCondition: '/amc/client/listApplyFormByCondition',
    // 根据活动Id和会员Id查询参赛作品列表
    listApplyFormByMemberId: '/amc/client/listApplyFormByMemberId',
    // 参赛作品投票
    topApplyForm: '/amc/client/topApplyForm',
    // 参赛作品详情
    getApplyFormDetail: '/amc/client/getApplyFormDetail',
}